import BaseModel from '@/models/base';

export default class Commission extends BaseModel {
  static entity = 'commissions';
  static apiPath = 'commissions';

  static fields() {
    return {
      id: this.attr(null),
      title: this.string(''),
    };
  }
}
